"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDevOverrides = exports.getStorageValues = exports.isDevEnabled = void 0;
const react_1 = require("react");
function isDevEnabled() {
    return window.location.search.includes("sc_dev=1");
}
exports.isDevEnabled = isDevEnabled;
function getStorageValues(supportedKeys, parseStorageValue) {
    const onLoadOverrides = {};
    for (let i = 0; i < window.localStorage.length; i++) {
        const nextKey = window.localStorage.key(i) ?? "";
        if (Object.hasOwn(supportedKeys, nextKey)) {
            onLoadOverrides[nextKey] = parseStorageValue(window.localStorage.getItem(nextKey) ?? "");
        }
    }
    return onLoadOverrides;
}
exports.getStorageValues = getStorageValues;
function useDevOverrides(supportedKeys, parseStorageValue) {
    const [devOverrides, setDevOverrides] = (0, react_1.useState)(() => isDevEnabled() ? getStorageValues(supportedKeys, parseStorageValue) : {});
    (0, react_1.useEffect)(() => {
        if (!isDevEnabled()) {
            return;
        }
        function onStorageChange(event) {
            const { key, newValue } = event;
            // If key is null, that means storage was cleared.
            if (key === null) {
                if (Object.keys(devOverrides).length > 0) {
                    setDevOverrides({});
                }
                return;
            }
            // Check if changed storage value fits the supported keys we are looking for
            if (!Object.hasOwn(supportedKeys, key)) {
                return;
            }
            if (newValue === null) {
                // Key was removed. Remove that override.
                setDevOverrides((prevOverrides) => {
                    const newOverrides = { ...prevOverrides };
                    delete newOverrides[key];
                    return newOverrides;
                });
                return;
            }
            // Set/update the override
            setDevOverrides((prevOverrides) => ({
                ...prevOverrides,
                [key]: parseStorageValue(newValue),
            }));
        }
        window.addEventListener("storage", onStorageChange);
        return () => window.removeEventListener("storage", onStorageChange);
    }, [supportedKeys]);
    return devOverrides;
}
exports.useDevOverrides = useDevOverrides;
